import { render, staticRenderFns } from "./Unconfirmed.vue?vue&type=template&id=f2505f7c&scoped=true"
import script from "./Unconfirmed.vue?vue&type=script&lang=js"
export * from "./Unconfirmed.vue?vue&type=script&lang=js"
import style0 from "./Unconfirmed.vue?vue&type=style&index=0&id=f2505f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2505f7c",
  null
  
)

export default component.exports